if($('.download_app_link').length > 0) {
  $('.download_app_link a').on('click', function(){
    localStorage.setItem("AppButton", "clicked");
  });
  var click = localStorage.getItem('AppButton');
  if(click == "clicked") {
    $('.download_app_link').remove();
  }
  
  $('.closeApp_link').on('click', function() {
    localStorage.setItem("AppButton", "clicked");
    $('.download_app_link').remove();
  });
}

$(document).ready(function() {
  $('.cartCollection_carousel').owlCarousel({
    loop:false,
    margin:7,
    nav:true,
    dots: false,
    items: 4
  });
  
  if($('.cartCollection_carousel').length > 0) {
    $('.slide_product.item a').on('click', function(event) {
      event.preventDefault();
      var proHref = $(this).attr('href');
          proHref = proHref.split('?=');
          $.ajax({
            url: proHref[0]+'.js',
            type: 'GET',
            dataType: 'json',
            success: function(result) {
              var formatMoney = (result.price).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
              });
              var compareMoney = (result.compare_at_price).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
              });
              $('.g_drawerPopup').css('display', 'flex');
              $('.g_drawerPopup .product_image').html('<img src="'+result.featured_image+'">');
              $('.g_drawerPopup .g_title').text(result.title);
              $('.g_drawerPopup .pro_price').html(formatMoney+'<s>'+compareMoney+'</s>');
              $('.g_drawerPopup .g_desc').html(result.description);
              $('.g_drawerPopup .g_addTOCartButton button').attr('data-id', proHref[1]);
            }
        });
    });

    $('.q_qtyBtn').on('click', function(event) {
       event.preventDefault(); event.stopImmediatePropagation();
      var inptVal = $(this).parent().find('input[name="g_updates"]').val();
      if($(this).hasClass('g_plus')){
        $(this).parent().find('[name="g_updates"]').val(+inptVal+1);
      
      }else { 
        if(inptVal > 1) {
          $(this).parent().find('[name="g_updates"]').val(+inptVal-1);
        }
      }
    });
    $('.g_closePopup').on('click', function(i) {
      i.preventDefault(); i.stopImmediatePropagation();
      $('.g_drawerPopup').hide();
    });
  }
});